export enum Shadows {
    BASE = '0px 1px 1px rgba(0, 0, 0, 0.25)',
    SMALL = '0px 2px 4px 1px rgba(9, 30, 66, 0.1)',
    XSMALL = '0px .75px .75px rgba(9, 30, 66, 0.1)',
    MEDIUM = '0px 1px 5px 2px rgba(194, 194, 194, 0.1)',
    LARGE = '0px 0px 10px rgba(0, 0, 0, 0.1)',
}
